export default __webpack_public_path__ + "static/media/stunningpunch1.fb206e64.png";